/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import { Box } from "@mui/material";
import ContentLoader from "react-content-loader";

export const ProcessBoxLoader = () => (
  <>
    <Box sx={{ display: { xs: "none", sm: "block" } }}>
      <ContentLoader height={270} width={500} speed={2} backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
        <rect x="90" y="10" rx="3" ry="3" width="160" height="10" />
        <rect x="90" y="30" rx="3" ry="3" width="380" height="6" />
        <rect x="90" y="50" rx="3" ry="3" width="140" height="6" />
        <rect x="90" y="100" rx="3" ry="3" width="160" height="10" />
        <rect x="90" y="120" rx="3" ry="3" width="380" height="6" />
        <rect x="90" y="140" rx="3" ry="3" width="140" height="6" />
        <rect x="90" y="190" rx="3" ry="3" width="160" height="10" />
        <rect x="90" y="210" rx="3" ry="3" width="380" height="6" />
        <rect x="90" y="230" rx="3" ry="3" width="140" height="6" />
        <circle cx="35" cy="30" r="20" />
        <circle cx="35" cy="120" r="20" />
        <circle cx="35" cy="210" r="20" />
      </ContentLoader>
    </Box>
    <Box sx={{ display: { xs: "block", sm: "none" } }}>
      <ContentLoader height={320} width={300} speed={2} backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
        <rect x="10" y="10" rx="3" ry="3" width="160" height="10" />
        <rect x="10" y="40" rx="3" ry="3" width="210" height="6" />
        <rect x="10" y="60" rx="3" ry="3" width="270" height="6" />
        <rect x="10" y="80" rx="3" ry="3" width="140" height="6" />
        <rect x="10" y="120" rx="3" ry="3" width="160" height="10" />
        <rect x="10" y="150" rx="3" ry="3" width="210" height="6" />
        <rect x="10" y="170" rx="3" ry="3" width="270" height="6" />
        <rect x="10" y="190" rx="3" ry="3" width="140" height="6" />
        <rect x="10" y="230" rx="3" ry="3" width="160" height="10" />
        <rect x="10" y="260" rx="3" ry="3" width="270" height="6" />
        <rect x="10" y="280" rx="3" ry="3" width="140" height="6" />
        <rect x="10" y="300" rx="3" ry="3" width="140" height="6" />
      </ContentLoader>
    </Box>
  </>
);
